import { Typography } from '@material-ui/core';
import { useStyles } from '../styles';
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import CardHeader from '@material-ui/core/CardHeader';
import Grid from '@material-ui/core/Grid';
import MomentCreateFilterDialog from './MomentCreateFilterDialog';
import React, { useState } from 'react';
import SimpleCollection from '../Organisms/SimpleCollection/';
import SimpleForm from '../Atoms/SimpleForm';
import SimpleGram from '../Atoms/SimpleGram';
import useGlobalStyles from '../../styles/globalStyles';

interface IMomentsSettings {
    toggleMomentConfigSetting: Function;
    config: {
        [key: string]: any;
    };
    createMomentFilter: Function;
    deleteMomentFilter: Function;
    updateMomentFilter: Function;
}
const UserContentSettings = ({ config, toggleMomentConfigSetting }: IMomentsSettings) => {
    return (
        <SimpleForm
            defaultValues={{
                userGeneratedPostsDisabled: config.userGeneratedPostsDisabled,
            }}
            fields={[
                {
                    label: 'Prevent users from creating posts',
                    name: 'userGeneratedPostsDisabled',
                    type: 'toggle',
                },
            ]}
            hideButton={true}
            id="Toggle-User-Generated-Posts-Disabled"
            onSubmit={(val: boolean) => toggleMomentConfigSetting(val)}
            submitOnChange={true}
        />
    );
};

const DownloadSettings = ({ config, toggleMomentConfigSetting }: IMomentsSettings) => {
    return (
        <SimpleForm
            defaultValues={{
                isDownloadEnabled: config.isDownloadEnabled,
            }}
            fields={[
                {
                    label: 'Users are allowed to download images',
                    name: 'isDownloadEnabled',
                    type: 'toggle',
                },
            ]}
            hideButton={true}
            id="Toggle-Moments-Download-Enabled"
            onSubmit={(val: boolean) => toggleMomentConfigSetting(val)}
            submitOnChange={true}
        />
    );
};

const CommentSettings = ({ config, toggleMomentConfigSetting }: IMomentsSettings) => {
    return (
        <SimpleForm
            defaultValues={{
                commentsEnabled: config.commentsEnabled,
            }}
            fields={[
                {
                    label: 'Users are allowed to comment on moments',
                    name: 'commentsEnabled',
                    type: 'toggle',
                },
            ]}
            hideButton={true}
            id="Toggle-Moments-Comments-Enabled"
            onSubmit={(val: boolean) => toggleMomentConfigSetting(val)}
            submitOnChange={true}
        />
    );
};

const LikeSettings = ({ config, toggleMomentConfigSetting }: IMomentsSettings) => {
    return (
        <SimpleForm
            defaultValues={{
                likesEnabled: config.likesEnabled,
            }}
            fields={[
                {
                    label: 'Users are allowed to like moments',
                    name: 'likesEnabled',
                    type: 'toggle',
                },
            ]}
            hideButton={true}
            id="Toggle-Moments-Likes-Enabled"
            onSubmit={(val: boolean) => toggleMomentConfigSetting(val)}
            submitOnChange={true}
        />
    );
};
const MomentsSettings = (props: IMomentsSettings) => {
    const globalClasses = useGlobalStyles();

    const classes = useStyles();
    const [dialog, setDialog] = useState(false);
    const handleFilterSubmit = (res: string) => {
        props.createMomentFilter({filter:res});
        setDialog(false);
    };
    return (
        <React.Fragment>
            <MomentCreateFilterDialog
                handleClose={() => setDialog(false)}
                onSubmit={handleFilterSubmit}
                open={dialog}
            />
            <Grid className={classes.contentWrapper} container spacing={3}>
                <Grid item md={4} xs={12}>
                    <Typography component="h2" gutterBottom={true} variant="h5">
                        General Settings
                    </Typography>
                    <Grid container direction="column" spacing={4}>
                        <Grid item xs>
                            <Card data-cy="SettingsWrapper">
                                <CardHeader classes={{ root: globalClasses.cardHeader }} title="User Content" />
                                <CardContent>
                                    <UserContentSettings {...props} />
                                </CardContent>
                            </Card>
                        </Grid>
                        <Grid item xs>
                            <Card data-cy="SettingsWrapper">
                                <CardHeader classes={{ root: globalClasses.cardHeader }} title="Image Downloading" />

                                <CardContent>
                                    <DownloadSettings {...props} />
                                </CardContent>
                            </Card>
                        </Grid>
                        <Grid item xs>
                            <Card data-cy="SettingsWrapper">
                                <CardHeader classes={{ root: globalClasses.cardHeader }} title="Comments" />
                                <CardContent>
                                    <CommentSettings {...props} />
                                </CardContent>
                            </Card>
                        </Grid>
                        <Grid item xs>
                            <Card data-cy="SettingsWrapper">
                                <CardHeader classes={{ root: globalClasses.cardHeader }} title="Likes" />

                                <CardContent>
                                    <LikeSettings {...props} />
                                </CardContent>
                            </Card>
                        </Grid>
                    </Grid>
                </Grid>
                <Grid item md={8} xs={12}>
                    <Typography component="h2" gutterBottom={true} variant="h5">
                        Filters
                    </Typography>
                    <Grid container spacing={4}>
                        <Grid item xs>
                            <SimpleCollection
                                data={props.config.imageFilters}
                                fabPosition="absolute"
                                fabRight={'0'}
                                itemRender={item => {
                                    return (
                                        <SimpleGram
                                            menuOptions={[
                                                {
                                                    callback: () => props.deleteMomentFilter(item.id),
                                                    label: 'Remove',
                                                },
                                            ]}
                                            primaryImageUrl={item.imageURL}
                                            showAvatar={false}
                                            showMenu={true}
                                        />
                                    );
                                }}
                                minHeight="125px"
                                mode="dark"
                                onCreate={() => setDialog(true)}
                                onSort={props.updateMomentFilter}
                                reorderable={true}
                                type="card"
                            />
                        </Grid>
                    </Grid>
                </Grid>
            </Grid>
        </React.Fragment>
    );
};

export default MomentsSettings;
